<template>
    <v-dialog v-model="visible" max-width="500px" persistent>
      <v-card>
        <v-toolbar color="primary" dark flat dense>
          <v-toolbar-title>Create New Task / Action Step</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
  
        <v-card-text class="pt-6">
          <v-form ref="taskForm" v-model="valid">
            <v-row dense>
              <v-col cols="12">
                <AutoCompleteCrudAdvanced table="tasks" label="Select Task" @input="getSelectedTask"></AutoCompleteCrudAdvanced>
                
              </v-col>
  
              <v-col cols="12">
                <AutoCompleteCrudAdvanced table="staff" label="Assign To Staff" @input="getSelectedStaff"></AutoCompleteCrudAdvanced>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="task.start"
                  label="Starting"
                  type="date"
                  outlined
                  dense
                  required
                  :rules="[v => !!v || 'Starting is required']"
                ></v-text-field>
              </v-col>
  
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="task.end"
                  label="Deadline"
                  type="date"
                  outlined
                  dense
                  required
                  :rules="[v => !!v || 'Deadline is required']"
                ></v-text-field>
              </v-col>
  
              <v-col cols="12">
                <AutoCompleteCrudAdvanced table="tasks_priorities" label="Priority Level" @input="getTaskPriority"></AutoCompleteCrudAdvanced>
                
                <!-- <v-select
                  v-model="task.priority"
                  :items="['Low', 'Medium', 'High', 'URGENT']"
                  label="Priority Level"
                  outlined
                  dense
                ></v-select> -->
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
  
        <v-divider></v-divider>
  
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="success" :disabled="!valid" @click="save">
            <v-icon left>mdi-calendar-check</v-icon> Create Task
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import AutoCompleteCrudAdvanced from "@/modules/CrudDatabases/AutoCompleteCrudAdvanced.vue"

  export default {
    props: {
      value: Boolean
    },
    components:{
      AutoCompleteCrudAdvanced
    },
    data() {
      return {
        valid: false,
      
        // Mock staff list - this would normally come from your database
        staffList: [],
        task: {
          id: null,
          task_id:null,
          title: '',
          assignedTo: '',
          start: new Date().toISOString().substr(0, 10),
          end: new Date().toISOString().substr(0, 10),
          priority_id:null,
          priority: 'Medium',
          status: 'todo',
          staff_id:null
        }
      };
    },
    computed: {
      visible: {
        get() { return this.value; },
        set(val) { this.$emit('input', val); }
      }
    },
    methods: {
      close() {
        this.visible = false;
        //this.resetForm();
      },
      getSelectedStaff(staffObj){
        this.task.staff_id = staffObj.id
        this.task.assignedTo = staffObj.name
      },
      getTaskPriority(taskPriorityObj){
        this.task.priority_id = taskPriorityObj.id
        this.task.priority = taskPriorityObj.name
      },
      getSelectedTask(taskObj){
        this.task.task_id = taskObj.id
        this.task.title = taskObj.name
      },
      // resetForm() {
      //   this.task = {
      //     id: null, // Simple unique ID generation
      //     task_id:null,
      //     title: '',
      //     assignedTo: '',
      //     end: new Date().toISOString().substr(0, 10),
      //     priority_id:null,
      //     priority: 'Medium',
      //     status: 'todo',
      //     staff_id:null
      //   };
    
      //   if (this.$refs.taskForm) {
      //     this.$refs.taskForm.resetValidation();
      //   }
      // },
      save() {
        if(!this.task.staff_id){
          this.$toast.info("Assign To Staff Required!")
          return false;
        }
        if (this.$refs.taskForm.validate()) {
          // Create a deep copy to emit
          const taskData = JSON.parse(JSON.stringify(this.task));
        
          this.$emit('save', taskData);
          this.close();
        }
      }
    }
  };
  </script>